import { deleteApi, get } from "../GenericServices";

const ProjectEstimateDocument = {
  projectEstimateDocumentDownload: (id) => {
    return get(`project-estimate-document/${id}/download`, {}, "blob");
  },
  projectEstimateDocumentDelete: (id) => {
    return deleteApi(`project-estimate-document/${id}`);
  },
};

export default ProjectEstimateDocument;
